let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aAk8i")).then(() => parcelRequire('5X5n5'));